export interface SiteDetailsMaster {
  id: number;
  siteName: string;
  siteNickname: string;
  city: string;
  countryId: number;
  countryName: string;
  companyId: number;
  formattedAddress: string;
  siteState: string;
  siteZip: string;
}
